import { create } from 'zustand';

// ==================== TYPES ====================

export interface ArtifactsState {
  // Current artifact being viewed/edited
  selectedArtifactId?: string;
  selectedArtifactType?: string;

  // Compilation state (similar to Resume Compiler)
  selectedMasterTemplateId?: string;
  selectedContentIds: string[];

  // Filters
  artifactTypeFilter?: string;
  statusFilter?: 'all' | 'draft' | 'published';

  // Methods
  setSelectedArtifact: (id?: string, type?: string) => void;
  clearSelectedArtifact: () => void;
  setSelectedTemplate: (id?: string) => void;
  toggleContentSelection: (id: string) => void;
  addContentSelection: (id: string) => void;
  removeContentSelection: (id: string) => void;
  clearSelection: () => void;
  setArtifactTypeFilter: (type?: string) => void;
  setStatusFilter: (status?: 'all' | 'draft' | 'published') => void;
}

// ==================== STORE ====================

export const useArtifactsStore = create<ArtifactsState>((set) => ({
  // Initial state
  selectedArtifactId: undefined,
  selectedArtifactType: undefined,
  selectedMasterTemplateId: undefined,
  selectedContentIds: [],
  artifactTypeFilter: undefined,
  statusFilter: 'all',

  // Methods
  setSelectedArtifact: (id?: string, type?: string) =>
    set({ selectedArtifactId: id, selectedArtifactType: type }),

  clearSelectedArtifact: () =>
    set({ selectedArtifactId: undefined, selectedArtifactType: undefined }),

  setSelectedTemplate: (id?: string) => set({ selectedMasterTemplateId: id }),

  toggleContentSelection: (id: string) =>
    set((state) => ({
      selectedContentIds: state.selectedContentIds.includes(id)
        ? state.selectedContentIds.filter((contentId) => contentId !== id)
        : [...state.selectedContentIds, id],
    })),

  addContentSelection: (id: string) =>
    set((state) => ({
      selectedContentIds: state.selectedContentIds.includes(id)
        ? state.selectedContentIds
        : [...state.selectedContentIds, id],
    })),

  removeContentSelection: (id: string) =>
    set((state) => ({
      selectedContentIds: state.selectedContentIds.filter((contentId) => contentId !== id),
    })),

  clearSelection: () =>
    set({
      selectedMasterTemplateId: undefined,
      selectedContentIds: [],
    }),

  setArtifactTypeFilter: (type?: string) => set({ artifactTypeFilter: type }),

  setStatusFilter: (status?: 'all' | 'draft' | 'published') =>
    set({ statusFilter: status || 'all' }),
}));
